import React from "react";
import style from "./JobsList.module.css";
import { Link } from "react-router-dom";
import LinkGen from "../../../Blog/LinkGen";
function JobsList({ listData }) {
  return (
    <ul className={style.listWrapper}>
      {listData.length === 0 ? (
        <li className={style.noData}>No Data to Display</li>
      ) : (
        listData.map(
          (data, index) => (
            <li key={index} className={style.list}>
              <Link
                to={`/job/${LinkGen(data.title)}`}
                className={style.singleItem}
              >
                <div className={style.jobListing}>
                  <div className={style.logoDiv}>
                    <img
                      alt=""
                      src="https://invozone.com/wp-content/uploads/2020/04/favicon.svg"
                      className={style.fig}
                    ></img>
                  </div>
                  <div className={style.textDiv}>
                    <h2 className={style.jobTitle}>{data.title}</h2>
                    <div className={style.company}>
                      <strong>InvoZone</strong>
                      <span className={style.tagLine}>
                        We push limits with innovative solutions
                      </span>
                    </div>
                  </div>
                </div>
                <div className={style.detailsWrapper}>
                  <div className={style.cityDiv}>
                    <span className={style.city}>{data.city}</span>
                  </div>
                  <div className={style.detail}>
                    <h2
                      className={`${style.type} ${
                        data.partTime
                          ? `${style.partTime}`
                          : `${style.fullTime}`
                      }`}
                    >
                      {data.type}
                    </h2>
                    <span className={style.date}>Posted on August 7, 2020</span>
                  </div>
                </div>
              </Link>
            </li>
          ),
          []
        )
      )}
    </ul>
  );
}

export default JobsList;
